import moment from "moment";
import React, { useEffect, useState, useRef } from "react";
import { Table } from "react-bootstrap";
// import Pagination from "../../../../../../../Reuseable/Pagination";
import { useParams, useHistory } from "react-router-dom";
import axios from "axios";
import LoaderPost from "../../../../../../../Reuseable/LoaderPost";
import AllDataHeader from "../../../../../../../Reuseable/AllDataHeader";
import cup from "../../../../../../../../assets/images/cup 2.png";
import { Link } from "react-router-dom";

const ReactCountsTable = () => {
  const [buffer, setBuffer] = useState(true);
  const [participantList, setParticipantList] = useState([]);
  const [roundList, setRoundList] = useState([]);
  const [selectedRound, setSelectedRound] = useState("");
  const [search, setSearch] = useState("");
  const [searchTimeout, setSearchTimeout] = useState(null);
  const inputRef = useRef(null);

  const { id } = useParams();
  const history = useHistory();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const page = urlParams.get("page") || 1;
    const round = urlParams.get("round") || "";
    const searchTerm = urlParams.get("search") || "";
    setSelectedRound(round);
    setSearch(searchTerm);
    onPageChange(page, searchTerm, round);
  }, []);

  const onPageChange = async (page, searchTerm = "", roundId = "") => {
    setBuffer(true);
    const urlParams = new URLSearchParams({
      page,
      search: searchTerm,
      round: roundId,
      type: "general",
    });
    history.replace(`${window.location.pathname}?${urlParams.toString()}`);
    await axios
      .get(
        `/api/audition-admin/react-count/list/${id}?page=${page}&search=${searchTerm}&round=${roundId}&type=general`
      )
      .then((res) => {
        if (res.data.status === 200) {
          setBuffer(false);
          // Transform pagination links to use frontend base URL
          const updatedLinks = res.data.auditionVideos.links.map((link) => {
            const linkParams = new URLSearchParams(link.url ? link.url.split('?')[1] : '');
            linkParams.set('search', searchTerm);
            linkParams.set('round', roundId);
            linkParams.set('type', 'general');
            const frontendBaseUrl = `/audition-admin/audition/react-count/${id}`;
            return {
              ...link,
              url: link.url ? `${frontendBaseUrl}?${linkParams.toString()}` : null,
            };
          });
          setParticipantList({
            ...res.data.auditionVideos,
            links: updatedLinks,
          });
          setRoundList(res.data.roundList);
          console.log("Links:", updatedLinks);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setBuffer(false);
      });
  };

  const handleSearchChange = (event) => {
    const value = event.target.value;
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }

    setSearch(value);
    const timeout = setTimeout(() => {
      onPageChange(1, value, selectedRound);
    }, 1000);

    setSearchTimeout(timeout);
  };

  const handleRoundChange = (event) => {
    const value = event.target.value;
    setSelectedRound(value);
    onPageChange(1, search, value);
  };

  const loveReactToMartConvert = (totalReacts = 0) => {
    return (totalReacts || 0);
  };

  const tableHead = [
    "#SL",
    "Name",
    "Phone",
    "Email",
    "Audition Title",
    "Round",
    "Start - End",
    "React Count",
    "Status",
  ];

  return (
    <>
      <AllDataHeader title="React Count List" image={cup} count={"Zero"} />
      {buffer ? (
        <LoaderPost />
      ) : (
        <>
          <div className="py-3">
            <h3 className="text-light text-center bg-dark py-3">
              <div className="row">
                <div className="col-md-4">
                  <input
                    type="text"
                    className="form-control bg-dark text-light"
                    name="search"
                    placeholder="Search Here"
                    value={search}
                    ref={inputRef}
                    onChange={handleSearchChange}
                  />
                </div>
                <div className="col-md-4"></div>
                <div className="col-md-4">
                  <select
                    className="form-select bg-dark text-light"
                    onChange={handleRoundChange}
                    value={selectedRound}
                  >
                    <option value="">All Rounds</option>
                    {roundList.map((round) => (
                      <option key={round.id} value={round.id}>
                        Round {round.round_num}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </h3>
            <div className="row mx-1" style={{ overflowX: "auto" }}>
              <Table className="table w-100" striped bordered hover variant="dark">
                <thead>
                  <tr>
                    {tableHead.map((heading) => (
                      <th className="bg-warning text-center" key={heading}>
                        {heading}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {participantList?.data && participantList.data.length > 0 ? (
                    participantList.data.map((participant, index) => (
                      <tr key={participant.id}>
                        <td>{index + 1}</td>
                        <td>
                          {participant.user?.first_name}{" "}
                          {participant.user?.last_name}
                        </td>
                        <td>{participant.user?.phone}</td>
                        <td>{participant.user?.email}</td>
                        <td>{participant.audition?.title}</td>
                        <td>{participant.round_info?.round_num}</td>
                        <td>
                          {moment(participant.audition?.start_date).format("LL")} -{" "}
                          {moment(participant.audition?.end_date).format("LL")}
                        </td>
                        <td style={{ fontFamily: 'Arial, sans-serif', fontSize: '14px', padding: '8px', textAlign: 'center' }}>
                          <span style={{ color: '#28a745' }}>{loveReactToMartConvert(participant.total_unpaid_reacts) || 0}</span>
                          <span style={{ color: '#6c757d' }}> + </span>
                          <span style={{ color: '#ffc107' }}>{loveReactToMartConvert(participant.total_paid_reacts) || 0}</span>
                          <span style={{ color: '#6c757d' }}> = </span>
                          <span style={{ color: '#007bff', fontWeight: 'bold' }}>{loveReactToMartConvert(participant.total_reacts) || 0} </span>
                          {loveReactToMartConvert(participant.total_boosted_reacts) ? <sub style={{ color: '#dc3545' }}>({loveReactToMartConvert(participant.total_boosted_reacts) || 0})</sub> : null}
                        </td>
                        <td style={{ color: participant.wining_status === 1 ? 'green' : 'red' }}>
                          {participant.wining_status === 1 ? "Passed" : "Failed"}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={tableHead.length} className="text-danger text-center">
                        No Data Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </div>
          <div id="react-paginate">
            {participantList?.data && participantList.data.length > 0 && (
              <Pagination
                links={participantList.links}
                onPageChange={(page) => onPageChange(page, search, selectedRound)}
              />
            )}
          </div>
        </>
      )}
    </>
  );
};

export default ReactCountsTable;

const Pagination = ({ links, onPageChange }) => {
  return (
    <nav>
      <ul className="pagination">
        {links.map((link, index) => (
          <li
            key={index}
            className={`page-item ${link.active ? 'active' : ''} ${!link.url ? 'disabled' : ''}`}
          >
            {link.url ? (
              <Link
                className="page-link"
                to={link.url}
                onClick={() => {
                  const urlParams = new URLSearchParams(link.url.split('?')[1]);
                  const page = urlParams.get('page') || 1;
                  onPageChange(page);
                }}
                dangerouslySetInnerHTML={{ __html: link.label }}
              />
            ) : (
              <span
                className="page-link"
                dangerouslySetInnerHTML={{ __html: link.label }}
              />
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
};

